<template>
   <section class="vue-select" >
     <span class="select" @click="toggleOption()" :class="{'no-select':currentName==''}"> {{ currentName?currentName:$t(tip) }} </span>
     <ul class="option-box" v-if="isShowOption">
       <li :class="{'active': item.code == currentValue}" @click="changeValue( item.code, item.name)" v-for="(item, index) in list" :key="index">
         {{ item.name }}
       </li>
     </ul>
   </section>
</template>
<script>
  export default {
    props:{
      value:{
        type: String,
        required:true
      },
      list: {
        type: Array
      },
      tip:{
        default: 'pleseSelect'
      }
    },
    data(){
      return{
        currentValue: this.value,
        currentName: '',
        isShowOption: false
      }
    },
    mounted() {
      if(this.currentValue === undefined){
        this.currentValue = '';
      }
      this.setName();

      //點擊外部隱藏下拉
      document.addEventListener('click',(e)=>{
        let thisClassName = e.target.className;
        if(thisClassName != 'select' && thisClassName != 'select no-select' && thisClassName != 'option-box'){
          this.isShowOption = false;
          console.log(thisClassName)
        }
      })
    },
    methods: {
      changeValue(val, name){
        this.currentValue = val;
        this.currentName = name;
        this.isShowOption = false;
        this.$emit("valueChanged", this.currentValue);
      },
      toggleOption(){
        this.isShowOption = !this.isShowOption;
      },
      leaveSelect(){
        this.isShowOption = false;
      },
      setName(){
        const [ chooseItem ] = this.list.filter((item) => { return this.currentValue === item.code });
        this.currentName = chooseItem ? chooseItem.name : '';
      }
    },
    watch: {
      //监听prop传的value，如果父级有变化了，将子组件的myValue也跟着变，达到父变子变的效果
      value(newVal) {
        this.currentValue = newVal;
        this.setName();
      },
      //监听myValue，如果子组件中的内容变化了，通知父级组件，将新的值告诉父级组件，我更新了，父级组件接受到值后页就跟着变了
     currentValue(newVal) {
        this.$emit('input', newVal)
      }
    }
  }
</script>
<style scoped lang="scss">
.vue-select{
  display: inline-block;
  width: 100%;
  height: 48px;
  position: relative;
  .select{
    display: block;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border: 1px solid #908782;
    border-radius: 24px;
    padding-left: 30px;
    background: url(../../assets/images/selectIcon.svg) no-repeat 97% center;
    &.no-select{
      color: #908782;
    }
  }
  input:focus{
    & + .option-box{
      display: block;
    }
  }
  .option-box{
    width: 100%;
    position: absolute;
    border: 1px solid #E4E7ED;
    border-radius: 4px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.06);
    z-index: 7;
    padding: 30px 0 20px;
    top: 68px;
    left: 0;
    max-height: 460px;
    overflow: auto;
    &:before{
      content: "";
      display: block;
      width: 17px;
      height: 10px;
      background: url("../../assets/images/arrow-top.png") no-repeat center;
      background-size: 180% auto;
      position: absolute;
      top: -6px;
      left: 35px;
    }
    li{
      height: 34px;
      padding: 6px 24px;
      line-height: 22px;
      font-size: 15px;
      letter-spacing: 0;
      color: #000;
      cursor: pointer;
      &.active, &:hover{
        color: #FFF;
        background-color: #D00717;
      }
    }
  }

}
.error{
  .select{
    border: 1px solid #D00717;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/default/vue-select.vue